"use client";
import { Box, Center, Heading, Stack, type StackProps } from "@chakra-ui/react";
import { PageBlockSection } from "lib/gcms";
import Image from "next/image";
import { FaArrowRight } from "react-icons/fa";
import { mapButton } from "utils/map-button";
import { insertLineBreaks } from "utils/resolve-template";

const flexStyles: { [key: string]: Partial<StackProps> } = {
  LEFT: {
    direction: {
      base: "column",
      lg: "row",
    },
  },
  RIGHT: {
    direction: {
      base: "column-reverse",
      lg: "row-reverse",
    },
  },
  CENTER: {
    direction: {
      base: "column",
    },
    alignItems: "center",
    justifyContent: "center",
    sx: {
      p: {
        py: {
          base: "6",
        },
      },
    },
  },
};

export const Section = ({
  title,
  subtitle,
  content,
  buttons,
  image,
  contentPosition,
  bg,
  color,
}: PageBlockSection) => {
  return (
    <Box as="section" bg={bg} color={color} py="12">
      <Box
        maxW={{ base: "xl", md: "7xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
      >
        <Stack
          spacing={{ base: "4", lg: "20" }}
          {...flexStyles[contentPosition]}
        >
          {image && (
            <Center
              flex="1"
              flexWrap="wrap"
              maxH="420px"
              maxW={{
                md: "lg",
                lg: "xl",
              }}
              alignItems="center"
              textAlign="center"
              display={{
                base: "none",
                lg: "inherit",
              }}
            >
              <Image
                {...image}
                style={{ objectFit: "contain" }}
                width={image?.width ? image?.width : 576}
                height={image?.height ? image?.height : 420}
                src={image?.url || " "}
                crossOrigin="anonymous"
                loading="lazy"
                blurDataURL={image?.blurDataURL ?? undefined}
                alt={image?.alt ?? ""}
              />
            </Center>
          )}
          <Box maxW={{ base: "xl", lg: "2xl" }} alignSelf={{ lg: "center" }}>
            <Box as="b">{subtitle}</Box>
            <Heading
              size="2xl"
              letterSpacing="tight"
              fontWeight="extrabold"
              lineHeight="normal"
              textAlign={contentPosition === "CENTER" ? "center" : "left"}
            >
              {insertLineBreaks(title)}
            </Heading>
            <Box as="div" fontSize="lg" mt="6" color={color}>
              {content}
            </Box>
            {buttons &&
              buttons.map((button: any) =>
                mapButton(button, {
                  className: "group",
                  mt: "8",
                  colorScheme: button?.theme,
                  size: "lg",
                  px: "8",
                  fontWeight: "bold",
                  h: "14",
                  iconSpacing: "3",
                  rightIcon: (
                    <Box
                      as={FaArrowRight}
                      fontSize="sm"
                      transition="transform 0.2s"
                      _groupHover={{ transform: "translateX(2px)" }}
                    />
                  ),
                }),
              )}
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default Section;
